import api from '@shared/services/api';
import { onErrorHandler } from '@shared/utils/errorHandlers';
import { showWarningMessage } from '@shared/utils/notifier';

export async function getPricingScenarioUserConfig(organizationId) {
  try {
    const userConfigData = await api.get(
      `/api/pe/organization/${organizationId}/pricing-scenario-user-configurations/user-default-scenario/`,
    );
    return userConfigData;
  } catch (e) {
    if (e.message.includes('404')) {
      // user does not have scenario config set up yet
      return null;
    }
    onErrorHandler(e, 'get-user-default-scenario');
  }
}

export async function createPricingScenarioUserConfig(
  organizationId,
  scenarioId,
) {
  try {
    const existingConfig = await getPricingScenarioUserConfig(organizationId);

    if (existingConfig) {
      return await api.patchJson(
        `/api/pe/organization/${organizationId}/pricing-scenario-user-configurations/${existingConfig.id}/`,
        {
          default_scenario: scenarioId,
        },
      );
    }

    return await api.postJson(
      `/api/pe/organization/${organizationId}/pricing-scenario-user-configurations/`,
      {
        default_scenario: scenarioId,
      },
    );
  } catch (e) {
    onErrorHandler(e, 'create-user-default-scenario');
  }
}

export async function updatePricingScenarioUserConfig(
  organizationId,
  configId,
  scenarioId,
) {
  try {
    return await api.patchJson(
      `/api/pe/organization/${organizationId}/pricing-scenario-user-configurations/${configId}/`,
      { default_scenario: scenarioId },
    );
  } catch (e) {
    onErrorHandler(e, 'update-user-default-scenario');
  }
}

export async function createPricingScenario(
  organizationId,
  scenarioName,
  pe3CustomRequest,
  customParameters,
) {
  const payload = {
    scenario: {
      name: scenarioName,
    },
    pe3_custom_request: { ...pe3CustomRequest, customParameters },
  };
  try {
    return await api.postJson(
      `/api/v1/organizations/${organizationId}/custom_pricing_scenarios/`,
      payload,
    );
  } catch (e) {
    if (
      e.response.data?.detail?.non_field_errors?.includes(
        'Scenario name already exists',
      )
    ) {
      showWarningMessage('A scenario with the same name already exists');
    }
    onErrorHandler(e, 'create-loan-scenario');
  }
}

export async function overridePricingScenario(
  organizationId,
  scenarioId,
  pe3CustomRequest,
  customParameters,
) {
  const payload = {
    scenario: {},
    pe3_custom_request: { ...pe3CustomRequest, customParameters },
  };
  try {
    return await api.putJson(
      `/api/v1/organizations/${organizationId}/custom_pricing_scenarios/${scenarioId}/`,
      payload,
    );
  } catch (e) {
    onErrorHandler(e, 'override-loan-scenario');
  }
}

export async function deletePricingScenario(organizationId, scenarioId) {
  try {
    return await api.delete(
      `/api/v1/organizations/${organizationId}/custom_pricing_scenarios/${scenarioId}/`,
    );
  } catch (e) {
    onErrorHandler(e, 'delete-loan-scenario');
  }
}

export async function getPricingScenarios(organizationId, options) {
  let url = `/api/v1/organizations/${organizationId}/custom_pricing_scenarios/`;

  url = api.constructUrl(url, options);
  try {
    return await api.get(url);
  } catch (e) {
    onErrorHandler(e, 'get-loan-scenarios');
  }
}

export async function getPricingScenario(organizationId, scenarioId, options) {
  let url = `/api/v1/organizations/${organizationId}/custom_pricing_scenarios/${scenarioId}/`;
  url = api.constructUrl(url, { ...options, classic: true });
  try {
    return await api.get(url);
  } catch (e) {
    if (e.message.includes('404')) {
      // user does not have scenario config set up yet
      return {};
    }
    onErrorHandler(e, 'get-loan-scenario');
  }
}
